import * as style from './style.css';
import React = require('react');

interface IProps {
    label: string;
    link: string
}
interface IState {

}

export default class LinkButton extends React.Component<IProps, IState> {
    render() {
        return (
            <a href={this.props.link} className={style.link}>
                <div className={style.linkButton}>
                    {this.props.children}
                    <span style={{ whiteSpace: 'nowrap' }} >
                        {this.props.label}
                    </span>
                </div>
            </a>
        );
    }
}
